module.exports = __webpack_public_path__ + "img/fcb-logo-en.4ab7edf4.png";